module.exports = "<button type=\"button\" (click)=\"descargar()\" [ngClass]=\"btnClass\">\n  <i class=\"fas fa-file-excel\"></i>\n  {{ label }}\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/boton-excel/boton-excel.component.html
// module id = ./src/app/components/tools/boton-excel/boton-excel.component.html
// module chunks = main